import {buttonVariants} from '@ezcater/tapas';
import Image from 'next/image';
import NextLink from 'next/link';
import useTranslation from 'next-translate/useTranslation';

import referFriendIllustration from '@/assets/images/illustrations/refer-a-friend.svg';
import useEzRewardsEligibility from '@/hooks/useEzRewardsEligibility';
import useRAFImprovements from '@/hooks/useRAFImprovements';
import useTracking from '@/hooks/useTracking';
import {REFER_A_FRIEND_PATH} from '@/paths';
import compilePath from '@/utils/compilePath';

const ReferAFriendCta: React.FC<unknown> = () => {
  const {t} = useTranslation('common');
  const {trackClick} = useTracking();
  const {canAccessEzRewards} = useEzRewardsEligibility();
  const {showRAFImprovements} = useRAFImprovements();

  if (!canAccessEzRewards || !showRAFImprovements) return null;

  const handleClick = () => trackClick('footer-refer-a-friend-cta');

  return (
    <div className="flex basis-1/2 items-center justify-between gap-4 rounded-2xl bg-green-50 p-6 tablet:gap-10">
      <div className="flex w-full flex-col justify-between gap-4">
        <div className="flex flex-col items-start gap-2">
          <h4 className="hidden text-left text-lg font-bold text-peppercorn-800 tablet:block">
            {t('components.ReferAFriendCta.title')}
          </h4>
          <h4 className="text-left text-base font-bold text-peppercorn-800 tablet:hidden">
            {t('components.ReferAFriendCta.titleMobile')}
            <br />
            {t('components.ReferAFriendCta.title2Mobile')}
          </h4>
          <p className="hidden text-left text-peppercorn-800 tablet:block">
            {t('components.ReferAFriendCta.description')}
          </p>
        </div>

        <NextLink
          aria-label={t('components.ReferAFriendCta.cta')}
          className={buttonVariants({
            className:
              'self-start py-[3px] text-base hover:text-peppercorn-800 hover:no-underline active:text-peppercorn-800 active:no-underline',
            size: 'small',
            variant: 'outlined',
          })}
          href={compilePath(REFER_A_FRIEND_PATH)}
          onClick={handleClick}
        >
          {t('components.ReferAFriendCta.cta')}
        </NextLink>
      </div>
      <Image
        alt=""
        className="h-[72px] w-[90px] tablet:h-20 tablet:w-[100px]"
        src={referFriendIllustration}
      />
    </div>
  );
};

export default ReferAFriendCta;
